/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_WebInputs */

const en_gc_editor_web = /** @type {(inputs: Gc_Editor_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web app`)
};

const zh_gc_editor_web = /** @type {(inputs: Gc_Editor_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网页版`)
};

/**
* | output |
* | --- |
* | "Web app" |
*
* @param {Gc_Editor_WebInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_web = /** @type {((inputs?: Gc_Editor_WebInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_WebInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_web(inputs)
	return zh_gc_editor_web(inputs)
});
export { gc_editor_web as "gc.editor.web" }